import { render, staticRenderFns } from "./AssetDetailDialog.vue?vue&type=template&id=0cf3920e&scoped=true"
import script from "./AssetDetailDialog.vue?vue&type=script&lang=js"
export * from "./AssetDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./AssetDetailDialog.vue?vue&type=style&index=0&id=0cf3920e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf3920e",
  null
  
)

export default component.exports